import React, { useEffect, useRef, useState } from 'react';
import './AudioLevelMeter.scss';


import { WebRTCsdkService } from '../../../services/webrtcsdk-service';
import { container } from "tsyringe";

import Indicator from './Indicator';
import { useSharedState } from '../../../utils/helpers';

interface AudioLeveLMeterProps {
  kind?: string;
}

const AudioLevelMeter = (props: AudioLeveLMeterProps) => {
  // component to avoid full refresh of parent on timerInterval

  let maxVal =  props.kind === 'haircheck' ? 4 : 10;

  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));
  const [sdkVolumeLevel] = useSharedState(webRTCsdkService.volumeLevel$);

  return (
    <Indicator name="microphone-indicator" indicatorValue={sdkVolumeLevel * maxVal} kind={props.kind}/>
  )

}

export default AudioLevelMeter;